"use client"

import { useEffect, useState } from "react"
import { Button, Card, Form, Radio, Input, Space, message } from "antd"
import { Container, Row, Col } from "react-bootstrap"
import "bootstrap/dist/css/bootstrap.min.css"
import "antd/dist/reset.css"
import Header from "../Header"
import Sidebar from "../Sidebar"
import FeatherIcon from "feather-icons-react"
import { Link } from "react-router-dom"

const AppointmentSettings = () => {
  const [isEditing, setIsEditing] = useState(false)
  const [form] = Form.useForm()

  const [settings, setSettings] = useState({
    patientRestriction: "none",
    earlyBooking: "none",
    earlyBookingCustom: "",
    lateBooking: "1hr",
    lateBookingCustom: "",
  })

  const handleEditClick = () => {
    setIsEditing(true)
    form.setFieldsValue(settings)
  }

  const handleSave = () => {
    form
      .validateFields()
      .then((values) => {
        setSettings({
          ...values,
          earlyBookingCustom: values.earlyBookingCustom || "",
          lateBookingCustom: values.lateBookingCustom || "",
        })
        setIsEditing(false)
        message.success("Settings saved successfully")
      })
      .catch(() => message.error("Please check the form for errors"))
  }

  const handleCancel = () => {
    setIsEditing(false)
    form.resetFields()
  }
useEffect(() => {
      const sidebar = document.getElementById("sidebar");
      if (sidebar) {
        sidebar.classList.add("sidebar-doctor");
        sidebar.id = "menu-item1"; // Change ID if needed
      }
      document.body.classList.remove("expand-menu");
    
          document.body.classList.add("mini-sidebar");
    }, []);
  return (
    <Container fluid>
      <Sidebar activeClassName="AppointmentSettings" />
      <div className="page-wrapper-doctor">
        <div className="content">
          <div className="page-header">
            <div className="row">
              <div className="col-sm-6">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="#">Doctor Dashboard </Link>
                  </li>
                  <li className="breadcrumb-item">
                    <FeatherIcon icon="chevron-right" />
                  </li>
                  <li className="breadcrumb-item active">Appointment Settings</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="card">
              <div className="card-body d-flex">
            <Row className="mb-4">
                <Col md={12}>
          <Card className="mb-4">
            <div className="d-flex justify-content-between mb-4">
              <h2 className="mr-5">Online Appointment Setting</h2>
              {!isEditing && (
                <Button type="primary" ghost onClick={handleEditClick}>
                  Edit
                </Button>
              )}
            </div>

            {!isEditing ? (
              <>
                <div className="border-bottom pb-3 mb-3">
                  <p className="text-muted mb-1">
                    Patient restrictions for video consultation appointment
                  </p>
                  <p className="mb-0">
                    {settings.patientRestriction === "none"
                      ? "No Restriction"
                      : "Allow only repeat patients to book video consultation appointment"}
                  </p>
                </div>

                <div className="border-bottom pb-3 mb-3">
                  <p className="text-muted mb-1">How early patient can book appointment?</p>
                  <p className="mb-0">
                    {settings.earlyBooking === "none"
                      ? "No Restriction"
                      : settings.earlyBooking === "custom"
                      ? `${settings.earlyBookingCustom} days`
                      : `${settings.earlyBooking.replace("days", "")} days`}
                  </p>
                </div>

                <div>
                  <p className="text-muted mb-1">Till when patient can book appointment?</p>
                  <p className="mb-0">
                    {settings.lateBooking === "none"
                      ? "No Restriction"
                      : settings.lateBooking === "custom"
                      ? `${settings.lateBookingCustom} hrs`
                      : settings.lateBooking}
                  </p>
                </div>
              </>
            ) : (
              <Form
                form={form}
                layout="vertical"
                initialValues={settings}
              >
                <div className="border-bottom pb-4 mb-4">
                  <Form.Item
                    label="Patient restrictions for video consultation appointment"
                    name="patientRestriction"
                    rules={[{ required: true, message: "Please select an option" }]}
                  >
                    <Radio.Group>
                      <Space direction="vertical">
                        <Radio value="none">
                          No restriction (i.e. Allow all new or repeat patients to book video consultation appointment)
                        </Radio>
                        <Radio value="repeat">
                          Allow only repeat patients to book video consultation appointment
                        </Radio>
                      </Space>
                    </Radio.Group>
                  </Form.Item>
                </div>

                <div className="border-bottom pb-4 mb-4">
                  <Form.Item
                    label="How early patient can book appointment?"
                    name="earlyBooking"
                    rules={[{ required: true, message: "Please select an option" }]}
                  >
                    <Radio.Group>
                      <Space wrap>
                        <Radio.Button value="none">No Restriction</Radio.Button>
                        <Radio.Button value="30days">30 days</Radio.Button>
                        <Radio.Button value="45days">45 days</Radio.Button>
                        <Radio.Button value="60days">60 days</Radio.Button>
                        <Radio.Button value="custom">Add Custom</Radio.Button>
                      </Space>
                    </Radio.Group>
                  </Form.Item>
                  {form.getFieldValue("earlyBooking") === "custom" && (
                    <Form.Item
                      name="earlyBookingCustom"
                      rules={[
                        { required: true, message: "Please enter days" },
                        { pattern: /^[0-9]+$/, message: "Please enter a valid number" },
                      ]}
                    >
                      <Input addonAfter="days" type="number" style={{ width: 150 }} />
                    </Form.Item>
                  )}
                  <p className="text-muted">For Example:</p>
                  <p className="text-muted fst-italic">
                    If set to 10 days, appointment for 20th March cannot be booked before 10th March
                  </p>
                </div>

                <div className="mb-4">
                  <Form.Item
                    label="Till when patient can book appointment?"
                    name="lateBooking"
                    rules={[{ required: true, message: "Please select an option" }]}
                  >
                    <Radio.Group>
                      <Space wrap>
                        <Radio.Button value="none">No Restriction</Radio.Button>
                        <Radio.Button value="15mins">15 mins</Radio.Button>
                        <Radio.Button value="30mins">30 mins</Radio.Button>
                        <Radio.Button value="45mins">45 mins</Radio.Button>
                        <Radio.Button value="1hr">1 hr</Radio.Button>
                        <Radio.Button value="custom">Add Custom</Radio.Button>
                      </Space>
                    </Radio.Group>
                  </Form.Item>
                  {form.getFieldValue("lateBooking") === "custom" && (
                    <Form.Item
                      name="lateBookingCustom"
                      rules={[
                        { required: true, message: "Please enter hours" },
                        { pattern: /^[0-9]+$/, message: "Please enter a valid number" },
                      ]}
                    >
                      <Input addonAfter="hrs" type="number" style={{ width: 150 }} />
                    </Form.Item>
                  )}
                  <p className="text-muted">For Example:</p>
                  <p className="text-muted fst-italic">
                    If set to 2 hours, a slot of 3:00 PM cannot be booked after 1:00 PM that day.
                  </p>
                </div>

                <div className="d-flex">
                  <Button onClick={handleCancel} className="me-2">
                    Cancel
                  </Button>
                  <Button type="primary" onClick={handleSave}>
                    Save
                  </Button>
                </div>
              </Form>
            )}
          </Card>
          </Col>
          </Row>
          </div>
          </div>
        </div>
      </div>
    </Container>
  )
}

export default AppointmentSettings